import React, { useEffect, useState } from "react";
import type { Configuration } from "../../model/Configuration";
import useConfiguration from "../../redux/Hooks/Kiosk/useConfiguration";
import { configurationChangeAction } from "../../redux/Actions";
import { useDispatchKiosk } from "../../redux/Hooks/Kiosk/useDispatchKiosk";
import { useLocale } from "@davi-ai/retorik-framework";
import translation from '../../translations/subMenuItems.json';
import commonTranslation from '../../translations/common.json';
import Button from "../Common/Button";
import TextField from "./TextField";
import tempConfigurationChangeAction from "../../redux/Actions/Kiosk/tempConfigurationChangeAction";

const Location = () => {
  const locale = useLocale();
  const configuration: Configuration = useConfiguration();
  const dispatch = useDispatchKiosk();
  const [latitude, setLatitude] = useState<string | undefined>(
    configuration?.position?.latitude?.toString()
  );
  const [longitude, setLongitude] = useState<string | undefined>(
    configuration?.position?.longitude?.toString()
  );
  const [city, setCity] = useState<string | undefined>(
    configuration?.position?.city
  );
  const [country, setCountry] = useState<string | undefined>(
    configuration?.position?.country
  );
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    setLatitude(configuration?.position?.latitude?.toString());
    setLongitude(configuration?.position?.longitude?.toString());
    setCity(configuration?.position?.city);
    setCountry(configuration?.position?.country);
  }, [configuration]);

  const checkError = () => {
    setErrorMessage("");
    if (
      (latitude !== undefined &&
        isNaN(parseFloat(latitude)) &&
        latitude !== "-") ||
      (longitude !== undefined &&
        isNaN(parseFloat(longitude)) &&
        longitude !== "-")
    ) {
      setErrorMessage("Please only enter numbers");
    }
  };

  const convertToFloat = (value: string | undefined) => {
    if (!value) return undefined;
    return parseFloat(value) || undefined;
  };

  const handleLatitudeChange = (event: any) => {
    checkError();
    setLatitude(event.target.value);
  };

  const handleLongitudeChange = (event: any) => {
    checkError();
    setLongitude(event.target.value);
  };

  const savePosition = () => {
    const position = {
      latitude: convertToFloat(latitude),
      longitude: convertToFloat(longitude),
      city: city,
      country: country,
    };

    const newConfiguration: Configuration = {
      ...configuration,
      position: position
    };
    if (!errorMessage) {
      dispatch(configurationChangeAction(newConfiguration));
      dispatch(tempConfigurationChangeAction({ position: position }));
    } else {
      setErrorMessage(`Location could not be saved: ${errorMessage}`);
    }
  };

  return (
    <div className="w-full flex flex-col gap-4 mt-6">
      {/* <p className="inline-flex gap-2">
        <span className="text-bold">
          {translation[locale]?.location.device || translation["fr-FR"].location.device}
        </span>
        {city && country ? `${city}, ${country}` : city || country || "unknown"}
      </p>
      <Button onClick={getDeviceLocation} label={translation[locale]?.location.getlocation || translation["fr-FR"].location.getlocation}>
        {translation[locale]?.location.getlocation || translation["fr-FR"].location.getlocation}
      </Button> */}
      <TextField
        label={translation[locale]?.location.latitude || translation["fr-FR"].location.latitude}
        onChange={handleLatitudeChange}
        value={latitude}
      />
      <TextField
        label={translation[locale]?.location.longitude || translation["fr-FR"].location.longitude}
        onChange={handleLongitudeChange}
        value={longitude}
      />
      {errorMessage && (
        <p className="italic text-yellow-300 text-center">{errorMessage}</p>
      )}
      <Button label={commonTranslation[locale]?.save || commonTranslation["fr-FR"].save} onClick={savePosition}>
        {commonTranslation[locale]?.save || commonTranslation["fr-FR"].save}
      </Button>
    </div>
  );
};

export default Location;
